<template>
	<!-- header header  -->
	<div class="header is_stuck">
		<nav class="navbar top-navbar navbar-expand-md navbar-dark">
			<!-- Logo -->
			<div class="navbar-header">
				<div v-if="isSuper" class="super">Super User</div>
				<a v-else class="navbar-brand" href="index.html">
					<router-link to="/" class="navbar-brand invisible-xs" exact>
						<img id="small-logo" :src="config.Params.SmallLogo" alt="Valley"/>
						<img id="full-logo" :src="config.Params.MainLogo" alt="Valley"/>
					</router-link>
				</a>
			</div>
			<!-- End Logo -->
			<div class="navbar-collapse">
				<sidebar-collapse :isCollapse="isCollapse" @collapse="collapse"></sidebar-collapse>
				<!-- User profile  -->
				<ul class="navbar-nav my-lg-0">

					<!-- Comment -->
					<li
							class="nav-item dropdown"
							:class="{'show': isNotification, '': !isNotification }"
							@click="handleNotification">
                            <span
									class="nav-link dropdown-toggle text-muted text-muted"
									style="cursor:pointer;"
									data-toggle="dropdown"
							>
                                <i class="fas fa-bell" ></i>
                                <div v-if="notifications.length" class="notify">
                                    <span class="heartbit"></span>
                                    <span class="point"></span>
                                </div>
                            </span>
						<div
								class="dropdown-menu dropdown-menu-right mailbox animated zoomIn"
								:class="{'show': isNotification, '': !isNotification }"
								@click="handleNotification"
						>
							<ul>
								<li>
									<div class="drop-title">Notifications</div>
								</li>
								<li>
									<div class="message-center notifications">
										<!-- Message -->
										<span v-for="(item, index) in notifications">
												<a href="#" @click="displayNotification(item.NotificationID, item.MessageLink)">
													<span v-html="item.MessageIcon"></span>
													<div class="mail-contnet">
														<h5><span v-html="item.MessageTitle"></span></h5> <span class="mail-desc" v-html="item.MessageBody"></span>
														<span class="time">{{ item.createdwhen }}</span>
													</div>
												</a>
											</span>
									</div>
								</li>
								<li>
									<a class="nav-link text-center" href="/notifications"> <strong>Check all notifications</strong> <i class="fas fa-angle-right" ></i> </a>
								</li>
							</ul>
						</div>
					</li>
					<!-- End Comment -->
					<!-- Messages -->
					<li
							class="nav-item dropdown"
							:class="{'show': isHelp, '': !isHelp }"
							@click="handleHelp"
					>
                            <span :class="{helpAvailable : helpText}"
								  class="nav-link dropdown-toggle text-muted text-muted"
								  style="cursor:pointer;" id="2"
								  data-toggle="dropdown">
                                <i class="fas fa-question-circle" ></i>
                            </span>
						<div
								class="dropdown-menu dropdown-menu-right mailbox dropdownhelp animated zoomIn"
								aria-labelledby="2"
								:class="{'show': isHelp, '': !isHelp }"
								@click="handleHelp"
						>
							<ul>
								<li>
									<div class="drop-title">Help</div>
								</li>
								<li>
									<div class="message-center helptext" v-html="(helpText ? helpText : 'No Help Text Available')"></div>
								</li>
							</ul>
						</div>
					</li>
					<!-- End Messages -->
					<!-- Profile -->
					<li class="nav-item dropdown"
						:class="{'show': isUserInfo, '': !isUserInfo }"
						@click="handleUserInfo"
					>
						<a class="nav-link dropdown-toggle text-muted  " href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<img v-if="currentUser.Params.avatar" :src="currentUser.Params.avatar" alt="user" class="profile-pic" />
							<img v-else :src="this.default_avatar" alt="user" class="profile-pic" />
						</a>
						<div
								class="dropdown-menu dropdown-menu-right animated zoomIn"
								:class="{'show': isUserInfo, '': !isUserInfo }"
						>
							<ul class="dropdown-user">
								<li><router-link to="/profile"><i class="btn-link fas fa-user" ></i> Profile</router-link></li>
								<li><router-link to="/notifications"><i class="btn-link fas fa-bell" ></i> Notifications</router-link></li>
								<li><router-link to="/logout"><i class="btn-link fas fa-sign-out-alt" ></i> Logout</router-link></li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
		</nav>
	</div>
</template>

<script>
	import SidebarCollapse from './SidebarCollapse.vue';
	import { mapGetters } from 'vuex';
	import axios from 'axios';
	import Util from '../../assets/js/util.js';

	export default{
		data(){
			return{
				isOpen: false,
				clickable: true,
				isNotification: false,
				isMessage: false,
				isUserInfo: false,
				notifications: [],
				isHelp: false,
			}
		},
		props:["config", "helpText", "isCollapse"],
		emits: ['collapse'],
		components:{
			SidebarCollapse
		},
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			default_avatar () {
				return require('../../images/default_avatar.png')
			},
			showLogo () {
				if (Util.isMobile()) {
					return false;
				} else {
					return true;
				}
			},
			isSuper () {
				return (localStorage.Super == 'y' ? true : false);
			}
		},
		methods: {
			collapse(data) {
				this.$emit('collapse', data);
			},
			toggle(e){
				//this.isOpen = !this.isOpen
				e.target.parentElement.classList.toggle('close')
			},
			handleMessage (e) {
				this.isMessage = !this.isMessage;
			},
			handleHelp (e) {
				this.isHelp = !this.isHelp;
			},
			handleNotification (e) {
				this.isNotification = !this.isNotification;
			},
			handleUserInfo (e) {
				this.isUserInfo = !this.isUserInfo;
			},
			logout (e) {
				window.location.href = 'logout';
			},
			getNotifications() {
				if (this.loggedInUser()) {
					//we do this as if we have a long running ajax job and a second call is made
					//the sessions are locked (some sort of phalcon thing) and causes the user to get logged out
					//while the long running ajax job is running...that is not good
					if (!this.longAjaxRunning()) {
						axios.post('/notifications/getunread'
						)
							.then(response => {
								if (response.data.result == 'success') {
									this.notifications = response.data.notifications;
								}
							}).catch(response => {
						});
					}
					setTimeout(() => {
						this.getNotifications()
					}, 30000);
				}
			},
			displayNotification(NotificationID, MessageLink) {
				axios.post('/notifications/read', {"NotificationID" : NotificationID},
				)
					.then(response => {
						if (response.data.result == 'success') {
							window.location.href = (MessageLink ? MessageLink : '/notifications');
						}
					}).catch(response => {
				});
			},
			loggedInUser () {
				if (Util.readCookie('login') && this.currentUser) {
					return true;
				} else {
					return false;
				}
			},
			longAjaxRunning () {
				if (Util.readCookie('scheduleRunning')) {
					return true;
				} else {
					return false;
				}
			},
		},
		mounted() {
			this.getNotifications();
		},
	}
</script>

<style lang="scss">
	.form-inline {
		display: block !important;
	}
	.notification-show + .dropdown-menu,
	.message-show + .dropdown-menu ,
	.language-show + .dropdown-menu  {
		display: block;
	}
	.header .top-navbar .navbar-header .navbar-brand {
		height: 35px;
		max-width: 250px;
	}
	div.header .top-navbar .navbar-header {
		background-color: var(--va-nav-bg, #0D1B2A);
	}
	.navbar-brand #small-logo,
	.mini-sidebar .navbar-brand #full-logo {
		//display: none;
	}
	.mini-sidebar .navbar-brand #small-logo {
		//display: inline;
	}
	#small-logo, #full-logo {
		width:auto;
		height:auto;
		max-height: 48px;
		max-width: 220px;
	}
	.header.is_stuck {
		min-height:54px;
		z-index:999;
	}
	.header.is_stuck .navbar {
		position: fixed;
		width: 100%;
		background: var(--va-nav-bg, #0D1B2A);
		box-shadow: 1px 0 5px rgba(0, 0, 0, 0.1);
	}
	.dropdownhelp .message-center li, .header .top-navbar .mailbox.dropdownhelp .message-center ul li {
		list-style: disc;
		margin-left: 17px;
		padding-left:0px;
		line-height: 10px;
		font-size:12px;
	}
	.header .top-navbar .mailbox.dropdownhelp .message-center p {
		margin-bottom: 0px;
		line-height: 20px;
		font-size:12px;
	}
	.header .top-navbar .mailbox.dropdownhelp .message-center {
		font-size:12px;
	}
	.dropdownhelp .message-center.helptext {
		min-height: 200px;
		height: auto;
		max-height: 400px;
	}
	.message-center.notifications div.btn {
		height: 33px;
	}
	.helpAvailable i {
		color: #28a745;
	}
	.super {
		border: 2px solid #000;
		padding: 0px;
		line-height: 37px;
		color: #FFF;
		font-weight: 800;
		height: 40px;
		font-size: 15px;
		display: inline-block;
		width: 100px;
		background-color: #DC3545;
	}
	@media (min-width: 500px) {
		.navbar-header {
			min-width: 240px;
		}
		#small-logo {
			display: none;
		}
		#full-logo {
			display: inline;
		}
	}
	@media (max-width: 499px) {
		.navbar-header {
			min-width: 130px;
		}
		#small-logo {
			display: inline;
		}
		#full-logo {
			display: none;
		}
	}
	.navbar-collapse i {
		color: #ccc;
	}
    .dropdown-menu-right {
        right: 0;
        left: auto;
    }
</style>
